<template>
  <easy-page-template
      title="辞書に関して、何を行いますか？"
      subtitle="辞書に関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemDictionary"
          title="辞書を管理する"
          to="/easy/systemHome/dictionary/management"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemDictionaryCreate"
          title="辞書を新たに作成する"
          to="/easy/systemHome/dictionary/creation"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemDictionary from "./assets/icon_system_dictionary.svg";
import iconSystemDictionaryCreate from "./assets/icon_system_dictionary_create.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "Dictionary",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemDictionary,
      iconSystemDictionaryCreate,
      imageTradeContract,
      dialogTokenImport: {
        visible: false
      }
    }
  },
}
</script>

<style scoped>

</style>
